import React from 'react';
import '../svg.css';


const Flooring = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >

            <g id="Logo"><rect id="frame" className="flooring-1" width="36" height="36" rx="10" /></g><g className="flooring-2"><path className="flooring-3" d="M24.89,9.2H18.57v3.69l4.54,4.54H26.8V11.11A1.92,1.92,0,0,0,24.89,9.2Z" /></g><rect className="flooring-3" x="15.13" y="15.13" width="5.74" height="5.74" transform="translate(-7.46 18) rotate(-45)" /><g className="flooring-2"><path className="flooring-3" d="M23.11,18.57l-4.54,4.54V26.8h6.32a1.92,1.92,0,0,0,1.91-1.91V18.57Z" /></g><g className="flooring-2"><path className="flooring-3" d="M11.11,9.2A1.92,1.92,0,0,0,9.2,11.11v6.32h3.32l4.91-4.55V9.2Z" /></g><g className="flooring-2"><path className="flooring-3" d="M12.52,18.57H9.2v6.32a1.92,1.92,0,0,0,1.91,1.91h6.32V23.12Z" /></g>
        </svg>
    );
};

export default Flooring;
